// extracted by mini-css-extract-plugin
export default {"actionButtonsContainer":"DocumentSearch_actionButtonsContainer__L-AV2","documentSearchLeftRegistryContainer":"DocumentSearch_documentSearchLeftRegistryContainer__9zTmE"};